import React from "react";
import { about } from "../mock";
import { asset } from "../assetBase";
import { BadgeCheck } from "lucide-react";

// Green section banner used across the page
export const SectionBanner = ({ title, id }) => (
  <div id={id} className="bg-lime-500 scroll-mt-20">
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-9">
      <h2 className="font-head font-semibold text-white text-2xl md:text-3xl tracking-wide">
        {title}
      </h2>
    </div>
  </div>
);

const About = () => {
  return (
    <section id="about" className="bg-white scroll-mt-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-start">
          <div className="reveal">
            <img
              src={asset(about.portrait)}
              alt="Greta Stojanovic"
              className="w-full max-w-md rounded-md shadow-lg object-cover"
              loading="lazy"
            />
          </div>

          <div className="reveal">
            <h2 className="font-head font-bold text-neutral-800 text-3xl md:text-4xl leading-snug">
              {about.heading}
            </h2>
            <div className="mt-7 space-y-5 text-neutral-600 tracking-body leading-relaxed text-[15px]">
              {about.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            {about.credential ? (
              <a
                href={about.credentialLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-8 group"
              >
                <img
                  src={about.credential}
                  alt="Academic credential"
                  className="w-40 rounded shadow-md transition-transform duration-300 group-hover:-translate-y-1"
                  loading="lazy"
                />
              </a>
            ) : (
              <a
                href={about.credentialLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-8 text-lime-600 hover:text-lime-700 font-head font-medium text-sm border-b border-transparent hover:border-lime-500 transition-colors"
              >
                <BadgeCheck size={18} /> View verified academic credential
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
